export type ResponseLike = {
  status: number
  answered?: boolean
  created?: number
}

export function responseStatusTitle(response: ResponseLike): string {
  switch (response.status) {
    case 1: return 'Новый'
    case 2: return 'Просмотрено'
    case 3: return 'Отказ'
    case 4: return response.answered ? 'Ответы записаны' : 'Доп. вопросы'
    case 5: return 'Онлайн-собеседование'
    case 6: return 'Собеседование в офисе'
    case 7: return 'Принят на работу'
    case 8: return 'Отменён'
    default: return 'Отклик'
  }
}

export function formatSalary(salary?: { min?: number | null, max?: number | null }): string {
  if (!salary || (salary.min == null && salary.max == null)) {
    return 'Зарплата не указана'
  }

  const min = salary.min == null ? '' : `от ${salary.min.toLocaleString('ru-RU')}`
  const max = salary.max == null ? '' : `до ${salary.max.toLocaleString('ru-RU')}`

  return [min, max].filter(Boolean).join(' ') + ' руб.'
}

export function formatShortDate(timestamp: number | Date): string {
  return new Date(typeof timestamp === 'number' ? timestamp * 1000 : timestamp).toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}
